import { render, staticRenderFns } from "./not-found.component.vue?vue&type=template&id=23371924&"
import script from "./not-found.component.vue?vue&type=script&lang=ts&"
export * from "./not-found.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports